import { render, staticRenderFns } from "./InventarioFlorestal.vue?vue&type=template&id=71d8ed70&scoped=true"
import script from "./InventarioFlorestal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventarioFlorestal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InventarioFlorestal.vue?vue&type=style&index=0&id=71d8ed70&prod&lang=css"
import style1 from "../../../css/crud.css?vue&type=style&index=1&id=71d8ed70&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8ed70",
  null
  
)

export default component.exports